module.exports = __webpack_public_path__ + "img/digital-twin-row.jpg";